module.exports = __webpack_public_path__ + "img/tic-tac-1.e806e7aa.png";